import React from 'react';
import I18n from 'i18n-js';
import { RCCloseButton } from '@reverbdotcom/cadence/components';

interface IProps {
  onRemoveFeedItem: () => void;
}

export function HideFeedItem(props: IProps) {
  return (
    <RCCloseButton
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onRemoveFeedItem();
      }}
      aria-label={I18n.t('discovery.feed.removeTooltip')}
      showTooltip
    />
  );
}

export default HideFeedItem;
